<template>
  <Layout>

    <div class="row justify-content-center">
      <div class="col-md-8 col-xl-6">
        <div>
          <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
          <center><span class="text-primary h6">You have no permission to View this Module</span></center>
        </div>
      </div>
    </div>
   
  </Layout>
</template>

<script>
// import axios from "axios";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";

export default {
  page: {
    title: "Coming Soon",
    meta: [{ name: "description", content: appConfig.description,},],
  },
  components: {
    Layout
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
    };
  },
};
</script>